class NewsletterForm extends HTMLElement {
    initialize() {
        this.emailField = this.querySelector('[name=email]');
        this.privacyConsentField = this.querySelector('[data-privacy-consent]');
        this.feedbackWrapper = this.querySelector('[data-feedback]');

        this.addEventListener('submit', this.handleFormSubmit.bind(this));
        this.emailField.addEventListener('input', BryanAnthonys.debounce(event => {
            event.target.parentElement.classList.remove('field--with-error');
        }, 500));
    }

    handleFormSubmit(event) {
        event.preventDefault();

        if (BryanAnthonys.isEUVisitor()) {
            if (this.privacyConsentField && !this.privacyConsentField.checked) {
                this.showPrivacyConsentError();

                return;
            }
        }

        if (!BryanAnthonys.validateEmail(this.emailField.value)) {
            this.emailField.parentElement.classList.add('field--with-error');
            this.showErrorMessage(BryanAnthonys.strings.general.invalidEmail);

            return;
        }

        this.subscribe();
    }

    subscribe() {
        const headers = {
            "accept": "*/*",
            "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
        };

        const fieldsElement = this.querySelector('[name="$fields"]');
        const fields = fieldsElement ? fieldsElement.value : '$source';

        const firstNameElement = this.querySelector('[name="$first_name"]');

        const body = new URLSearchParams({
            "$fields": fields,
            "g": this.querySelector('[name="g"]').value,
            "email": this.emailField.value,
            "$first_name": firstNameElement ? firstNameElement.value : '',
            "$timezone_offset": (new Date).getTimezoneOffset()/-60
        });

        fields.split(',').forEach(field => {
            body.set(field, this.querySelector(`[name="${field}"]`).value);
        });

        const fetchParams = {
            headers, body, "method": "POST"
        };

        const button = this.querySelector('[type="submit"]');
        button.classList.add('loading');

        fetch(this.dataset.subscribeUrl, fetchParams)
            .then(response => {
                if (!response.ok) {
                    throw response;
                }

                return response.json();
            })
            .then(response => {
                if (response.errors && response.errors.length) {
                    BryanAnthonys.reportIssue(
                        'other',
                        {errors: response.errors, request: body.toString()},
                        'Failed to subscribe to newsletter',
                        'throttled'
                    );
                    throw JSON.stringify(response.errors);
                }

                this.emailField.value = '';
                this.showSuccessMessage();

                document.dispatchEvent(new CustomEvent('subscribedToNewsletter', {
                    detail: {
                        type: this.dataset.type,
                        body
                    }
                }));
            })
            .catch(error => {
                console.log(error);
                this.showErrorMessage(BryanAnthonys.strings.general.genericAjaxError);
            })
            .finally(() => button.classList.remove('loading'));
    }

    showPrivacyConsentError() {
        this.privacyConsentField.parentElement.insertAdjacentHTML('beforeend', `
            <span class="animated-pointed-up-hand" data-consent-indicator>☝️</span>
        `);

        setTimeout(() => {
            this.privacyConsentField.parentElement.querySelectorAll('[data-consent-indicator]').forEach((consentIndicator) => {
                consentIndicator.remove();
            });
        }, 2000);

        this.showErrorMessage(BryanAnthonys.strings.newsletter.errorConsentMessage);
    }

    showErrorMessage(errorMessage) {
        if (!this.feedbackWrapper) {
            return;
        }

        this.feedbackWrapper.innerHTML = `
            <div class="status-banner status-banner--error mb-3" role="alert" data-error-message></div>
        `;

        this.feedbackWrapper.querySelector('[data-error-message]').textContent = errorMessage;
    }

    showSuccessMessage() {
        if (!this.feedbackWrapper) {
            return;
        }

        const successMessageTemplate = this.querySelector('[data-success-message-template]');
        const successMessage = successMessageTemplate && successMessageTemplate.innerHTML
            ? successMessageTemplate.innerHTML
            : BryanAnthonys.strings.newsletter.successMessage;

        // eslint-disable-next-line no-unsanitized/property
        this.feedbackWrapper.innerHTML = `
            <div class="status-banner status-banner--success mb-3" role="alert">
                ${successMessage}
            </div>
        `;
    }
}

customElements.define('newsletter-form', NewsletterForm);

class NewsletterAdditionalPopup extends HTMLElement {
    connectedCallback() {
        document.addEventListener('subscribedToNewsletter', event => {
            const showForTypes = String(this.dataset.showForTypes).split(',').map(type => type.trim());
            const modal = document.getElementById('newsletterAdditionalPopup');
            const email = event.detail.body.get('email');

            if (showForTypes.includes(event.detail.type) && email) {
                modal.querySelector('[name="email"]').value = email;
                modal.show();
            } else if (event.detail.type === 'additional') {
                modal.hide();
            }
        });
    }
}

customElements.define('newsletter-additional-popup', NewsletterAdditionalPopup);

customElements.define('newsletter-birthday-selector', class extends HTMLElement {
    connectedCallback() {
        const birthdayField =  this.querySelector('[name="birthday"]');
        const monthField =  this.querySelector('[name="birthday_month"]');
        const dayField =  this.querySelector('[name="birthday_day"]');
        const year = 1990;

        this.addEventListener('input', () => {
            if (monthField.value && dayField.value) {
                birthdayField.value = `${year}-${monthField.value}-${dayField.value}`;
            }
        });
    }
});

class NewsletterFormInitializer extends HTMLElement {
    connectedCallback() {
        if (typeof this.parentElement.initialize === 'function') {
            this.parentElement.initialize();
        }
    }
}

customElements.define('newsletter-form-initializer', NewsletterFormInitializer);